import Store  from 'store'

export default function () {
    return {
        setValue: (key, value) => Store.set(key, value),
        getValue: key => Store.get(key),
        clearAll: () => Store.clearAll(),
        removeValue: key => Store.remove(key)
    }
}


// WEBPACK FOOTER //
// ./localStorage.js